import { render } from "./Badges.vue?vue&type=template&id=2b4ba043"
import script from "./Badges.vue?vue&type=script&lang=ts"
export * from "./Badges.vue?vue&type=script&lang=ts"
script.render = render

export default script